module.exports = __webpack_public_path__ + "img/EQ.3c79933e.png";